import React, { useEffect, useRef, useState } from "react";
import { useLocation,useNavigate } from 'react-router-dom';
import axios, { AxiosError } from 'axios';
import config from "../config";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IndustryCard from "../components/IndustryCard";
import { Link } from "react-router-dom";

const Home: React.FC = () => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dots, setDots] = useState<number[]>([]);
  const [cardsPerScreen, setCardsPerScreen] = useState(0);
  const [faqActiveIndex, setFaqActiveIndex] = useState<number | null>(null);
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const handleResize = () => {
      const cards = slider.querySelectorAll<HTMLDivElement>(".feedback-card");
      const cardWidth = cards[0]?.offsetWidth || 0;
      const screenWidth = slider.offsetWidth;
      const totalCards = cards.length;
      const newCardsPerScreen = cardWidth > 0 ? Math.floor(screenWidth / cardWidth) : 0;
      const totalScreens = newCardsPerScreen > 0 ? Math.ceil(totalCards / newCardsPerScreen) : 0;

      setCardsPerScreen(newCardsPerScreen);
      setDots(Array.from({ length: totalScreens }, (_, i) => i));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const handleScroll = () => {
      const cardWidth = slider.querySelector<HTMLDivElement>(".feedback-card")?.offsetWidth || 0;
      if (cardWidth === 0 || cardsPerScreen === 0) return;

      const newCurrentIndex = Math.floor(slider.scrollLeft / (cardWidth * cardsPerScreen));
      setCurrentIndex(newCurrentIndex);
    };

    slider.addEventListener("scroll", handleScroll);

    return () => {
      slider.removeEventListener("scroll", handleScroll);
    };
  }, [cardsPerScreen]);

  const scrollToIndex = (index: number) => {
    const slider = sliderRef.current;
    if (!slider) return;

    const cardWidth = slider.querySelector<HTMLDivElement>(".feedback-card")?.offsetWidth || 0;
    if (cardWidth === 0 || cardsPerScreen === 0) return;

    slider.scrollTo({
      left: cardWidth * cardsPerScreen * index,
      behavior: "smooth",
    });
    setCurrentIndex(index);
  };

  const toggleFaq = (index: number) => {
    setFaqActiveIndex(faqActiveIndex === index ? null : index);
  };

  // Scroll to section based on URL hash
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]);

  useEffect(() => {
    document.title = "Accurate Materials Price Lists for Home Service Professionals | AccuPrice";

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "AccuPrice",
      "url": "https://accupricelists.com",
      "logo": "https://accupricelists.com/wp-content/uploads/2024/01/accuprice-logo.png",
      "description": "AccuPrice provides real-time material pricing lists for contractors and electricians, helping you build estimates and invoices faster with accurate supplier data.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "United States"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Support",
        "email": "contact@accupricelists.com",
        "availableLanguage": "English"
      },
      "sameAs": [
        "https://www.facebook.com/accupricelists",
        "https://www.linkedin.com/company/accupricelists"
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const navigate_toregister=() =>{
    const email = localStorage.getItem('email');
    if (email){
      navigate('/dashboard/subscriptions')
    }else{

      navigate('/register')
    }
  }

  const handleemailSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    
    if (!email) {
      toast('Please enter an email address', { type: 'error' });
      return;
    }

    try {
      await axios.post(`${config.apiBaseUrl}/newsletter_email/`, { email });
      toast('Successfully subscribed to our newsletter!', { type: 'success' });
      setEmail(''); // Clear the email input after successful submission
    } catch (error) {
      const errorMessage = axios.isAxiosError(error) 
        ? error.response?.data?.error || 'Failed to subscribe'
        : 'An unexpected error occurred';
      toast(errorMessage, { type: 'error' });
    }
  };
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
      />
      {/* Home Section */}
      <section id="hero-section" className="home">
        <div className="home-content">
          <div className="text-content">
            <h1>Accurate Materials Price Lists for Electrical Contractors</h1>
            <a 
              href="https://calendly.com/contact-accupricelists/question-or-help-with-accuprice" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                backgroundColor: "orange",
                color: "white",
                padding: "0.75rem 1.5rem",
                fontSize: "1rem",
                fontWeight: "bold",
                borderRadius: "10px",
                textDecoration: "none",
                textAlign: "center",
                cursor: "pointer",
                marginBottom: "1rem",
              }}
            >
              Got Some Questions? Book an onboarding call for 40% OFF
            </a>
            <a
              href="https://accupricelists.com/dashboard"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                backgroundColor: "white", 
                color: "orange",
                padding: "0.75rem 1.5rem",
                fontSize: "1rem",
                fontWeight: "bold",
                borderRadius: "10px",
                textDecoration: "none",
                textAlign: "center",
                cursor: "pointer",
                marginBottom: "1rem",
              }}
            >
              Sign Up Now And Try It Out!
            </a>
          </div>
          <div className="video-content">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/eN-uvEAri4o?autoplay=1&mute=1&rel=0&showinfo=0&controls=1&loop=1&playlist=eN-uvEAri4o"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      {/* Compatibility Section */}
      <section className="compatibility-section">
        <h2 className="section-heading">Compatible Software</h2>
        <p className="section-subtitle">Our Accuprice Lists are compatible with any software that allows for bulk upload of items. Here are a few examples:</p>
        <div className="compatibility-logos">
          <img src="/images/procore.png" alt="Procore logo integration" className="logo" />
          <img src="/images/housecallpro.png" alt="Housecall Pro integration logo" className="logo" />
          <img src="/images/quickbooks.png" alt="QuickBooks logo integration" className="logo" />
          <img src="/images/servicetrade.png" alt="ServiceTrade integration logo" className="logo" />
          <img src="/images/jobber.png" alt="Jobber integration logo" className="logo" />
          <img src="/images/workiz.png" alt="Workiz" className="logo" />
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section" id="feature">
        <h2 className="section-heading">WHY ACCUPRICE?</h2>
        <p className="section-subtitle">
          Up to date pricelists you can download monthly and upload to your estimation and invoicing software. Have confidence that your products
          and materials are priced accurately and marked up exactly how much you want!
        </p>
        <div className="features-content">
          <img src="/images/features-latop.png" alt="Laptop displaying AccuPriceLists features dashboard" className="features-laptop" />
          <div className="features-details">
            <h3 className="features-subheading" id="your-accurate-contractor-price-manager">YOUR ACCURATE CONTRACTOR PRICE MANAGER</h3>
            <ul className="features-list">
              <li><img src="/images/tick-with-circle.png" alt="Checkmark icon inside a circle" />Monthly updates to ensure current pricing accuracy.</li>
              <li><img src="/images/tick-with-circle.png" alt="Checkmark icon inside a circle" />Batch Import our materials list into QuickBooks and other software programs</li>
              <li><img src="/images/tick-with-circle.png" alt="tick" />Consistent product lists and descriptions from each monthly edition</li>
              <li><img src="/images/tick-with-circle.png" alt="tick" />Enter your desired markup for various price ranges</li>
              <li><img src="/images/tick-with-circle.png" alt="tick" />You have the option to include sale tax, Inventory options, and income type</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <h2 className="section-heading">What's in the Accuprice Electrical Pricelist?</h2>
        <div className="industries-content">
          {/* Electrical Industry Card */}
          <IndustryCard
            title={"Electrical"}
            imagePath={"/images/electrical.png"}
            link="/electrical"
          >
            <h3> Now Available!</h3>
            <p>The Accuprice Electrical Pricelist contains 1,000+ materials for all your residential and light commercial needs. All products have been selected and reviewed by expert electricians with decades of experience.</p>
            <ul>
              <li>300+ Conduit Fittings</li>
              <li>200+ Wires</li>
              <li>100+ Breakers</li>
              <li>50+ Breaker Boxes</li>
              <li>Indoor Junction Boxes, Outdoor Junction Boxes, and 4S Boxes</li>
              <li>Wiring Accessories</li>
              <li>Covers, Receptacles, and Switches</li>
              <li>And many more items!</li>
            </ul>
          </IndustryCard>
        </div>
      </section>

      {/* Steps Section */}
      <section className="steps-section">
        <h2 className="section-heading">Effortless Pricing With <span className="accuprice-highlight">Accuprice</span></h2>
        <p className="section-subtitle">Follow these simple steps to get started with AccuPrice</p>
        <div className="accuprice-steps">
          <div className="step step-left">
            <div className="step-content">
              <div className="step-number">Step 1</div>
              <h2 className="step-title">Sign up</h2>
              <p className="step-description">Create an account to access our user portal.</p>
            </div>
          </div>
          <div className="step step-right">
            <div className="step-content">
              <div className="step-number">Step 2</div>
              <h2 className="step-title">Choose Your Price List</h2>
              <p className="step-description">Select the specific price list you need (electrical, plumbing, lumber, etc.).</p>
            </div>
          </div>
          <div className="step step-left">
            <div className="step-content">
              <div className="step-number">Step 3</div>
              <h2 className="step-title">Purchase or Subscribe</h2>
              <p className="step-description">
                Opt for a limited free edition or purchase the complete price list with price updates for 12 months.
              </p>
            </div>
          </div>
          <div className="step step-right">
            <div className="step-content">
              <div className="step-number">Step 4</div>
              <h2 className="step-title">Customize Your List</h2>
              <p className="step-description">
                Configure the price lists to include your specific profit markups and sales tax rates. You can set different markups for various price ranges to tailor the lists to your business needs.
              </p>
            </div>
          </div>
          <div className="step step-left">
            <div className="step-content">
              <div className="step-number">Step 5</div>
              <h2 className="step-title">Download the Excel File</h2>
              <p className="step-description">Download the customized price list as an Excel file, ready for use.</p>
            </div>
          </div>
          <div className="step step-right">
            <div className="step-content">
              <div className="step-number">Step 6</div>
              <h2 className="step-title">Integrate with Your Software</h2>
              <p className="step-description">Import the price list into QuickBooks or other software programs to streamline your estimates and invoices.</p>
            </div>
          </div>
          <div className="step step-left">
            <div className="step-content">
              <div className="step-number">Step 7</div>
              <h2 className="step-title">Generate Accurate Estimates and Invoices</h2>
              <p className="step-description">
                Use the updated price lists to produce accurate and professional estimates and invoices, enhancing your efficiency and credibility.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="video-section">
        <h2 className="section-heading">Your First Steps with <span className="brand-name">Accu</span><span
            className="brand-name2">Price</span></h2>
        <div className="video-placeholder">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/2FCo43XutGM?si=zOFbFGsopvc2S8yO"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </section>

      {/* Price secrion */}
      <section className="price-section" id="pricing">
        <h2 className="section-heading">Pricing Plan</h2>
        <p className="section-subtitle">Choose the plan that fits your needs and start enjoying seamless service today.</p>
        <div className="price-section-wraper">
          <div className="price-cards-section">
            <div className="price-card price-card1">
              <div>
                <div className="price-dollar-icon">
                  <img className="dollar-icon" src="/images/dollar-icon.svg" alt="" />
                </div>
                <div className="price-amount-section">
                  <h4 className="price-amount-title">Free Wire and Conduit Demo</h4>
                  <h3 className="price-amount">$0</h3>
                </div>
                <div className="price-hr" ></div>
                <div className="price-includes-section">
                  <h4 className="price-includes-title">Includes:</h4>
                  <div className="inlcude-items-section">

                    <div className="inlucde-list-item">
                      <img className="tick-icon" src="/images/tick-icon.svg" alt="" />
                      <p className="inlcude-text">All the wire and conduit needed to get started</p>
                    </div>
                    <div className="inlucde-list-item">
                      <img className="tick-icon" src="/images/tick-icon.svg" alt="" />
                      <p className="inlcude-text">Customizable Mark Up and Taxes</p>
                    </div>
                    <div className="inlucde-list-item">
                      <img className="tick-icon" src="/images/tick-icon.svg" alt="" />
                      <p className="inlcude-text">Access to free price updates for all items</p>
                    </div>

                  </div>
                </div>
              </div>
              <div className="price-button">
                <button className="price-button-move" onClick={navigate_toregister}>Get started</button>
              </div>
            </div>


            <div className="price-card price-card2">
              <div>
                <div className="price-dollar-icon">
                  <img className="dollar-icon" src="/images/dollar-icon.svg" alt="" />
                </div>
                <div className="price-amount-section">
                  <h4 className="price-amount-title">Annual Plan (12 Editions paid annually)</h4>
                  <h3 className="price-amount">$35/Month</h3>
                  <h4>Normally <span className="price-amount-cut">$50/Month</span></h4>
                </div>
                <div className="price-hr"></div>
                <div className="price-includes-section" style={{ marginBottom: "1.5rem" }}>
                  <h4 className="price-includes-title">Includes:</h4>
                  <div className="inlcude-items-section">
                    <div className="inlucde-list-item">
                      <img className="tick-icon" src="/images/tick-icon.svg" alt=""/>
                      <p className="inlcude-text">Complete access to over 1000 items for your industry</p>
                    </div>
                    <div className="inlucde-list-item">
                      <img className="tick-icon" src="/images/tick-icon.svg" alt=""/>
                      <p className="inlcude-text">Money-back guarantee</p>
                    </div>
                     <div className="inlucde-list-item">
                      <img className="tick-icon" src="/images/tick-icon.svg" alt=""/>
                      <p className="inlcude-text">12 months of price updates for all of your items</p>
                    </div>
                    <div className="inlucde-list-item">
                      <img className="tick-icon" src="/images/tick-icon.svg" alt=""/>
                      <p className="inlcude-text">Customizable Mark Up and Taxes</p>
                    </div>
                    <div className="inlucde-list-item">
                      <img className="tick-icon" src="/images/tick-icon.svg" alt=""/>
                      <p className="inlcude-text">New Edition Notifications</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="price-button">
                <button className="price-button-move" onClick={navigate_toregister}>Get started</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <h2 className="section-heading">Benefits</h2>
        <p className="section-subtitle">Discover the Advantages of AccuPrice</p>
        <div className="benefits-container">
          <div className="benefit-item">
            <div className="benefit-icon">
              <i className="fas fa-dollar-sign"></i>
            </div>
            <h2 className="benefit-title">Accurate and Up-to-Date Pricing</h2>
            <p className="benefit-description">
              Our updated price lists allow you to provide accuratly priced and detailed estimates that can allow you to line itemize your materials for nearly every job. 
            </p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">
              <i className="fas fa-mouse-pointer"></i>
            </div>
            <h2 className="benefit-title">Ease of Use</h2>
            <p className="benefit-description">
              No more searching online and calling warehouses to get prices, with Accuprice our updated lists will be integrated directly into your estimating and invoicing software.
            </p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">
              <i className="fas fa-boxes"></i>
            </div>
            <h2 className="benefit-title">Comprehensive Coverage</h2>
            <p className="benefit-description">
              Our price lists cover a wide range of materials, ensuring you have access to the pricing information you need for any project.
            </p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">
              <i className="fas fa-clock"></i>
            </div>
            <h2 className="benefit-title">Save Time</h2>
            <p className="benefit-description">
              Our price lists are designed to save you time on estimating, so you can focus on other aspects of your business.
            </p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <h2 className="benefit-title">Improve Accuracy</h2>
            <p className="benefit-description">
              Our price lists are updated monthly, so you can be sure that your estimates are accurate.
            </p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">
              <i className="fas fa-chart-line"></i>
            </div>
            <h2 className="benefit-title">Increase Profitability</h2>
            <p className="benefit-description">
              Our price lists are designed to help you increase your profitability by providing you with accurate pricing information.
            </p>
          </div>
        </div>
      </section>

      {/* Customer Feedback Section */}
      <section className="customer-feedback-container">
        <h2 className="section-heading">Our Customer Feedback</h2>
        <p className="section-subtitle">Don't take our word for it. Trust our customers</p>
        <div className="customer-feedback-slider" ref={sliderRef}>
          {/* Repeat feedback-card divs as necessary */}
          <div className="feedback-card">
            <div className="feedback-header">
              <div className="feedback-avatar">
                <img src="/images/avatar.png" alt="User avatar or testimonial photo" className="feedback-avatar" />
              </div>
              <div className="feedback-stars">★★★★<span className="half-star">☆</span></div>
            </div>
            <h3 className="feedback-name">Charles B.</h3>
            <p className="feedback-title">Electrical Contractor</p>
            <p className="feedback-text">It was a little expensive, but I appreciate the guys giving me a discount code. Works well with my Quickbooks where I make my estimates.</p>
          </div>
          <div className="feedback-card">
            <div className="feedback-header">
              <div className="feedback-avatar">
                <img src="/images/avatar.png" alt="User avatar or testimonial photo" className="feedback-avatar" />
              </div>
              <div className="feedback-stars">★★★★★</div>
            </div>
            <h3 className="feedback-name">John C.</h3>
            <p className="feedback-title">Electrical Contractor</p>
            <p className="feedback-text">It's surprisingly easy to use the prices sheet they give you. My old prices have been way off over the years compared to this list.</p>
          </div>
          <div className="feedback-card">
            <div className="feedback-header">
              <div className="feedback-avatar">
                <img src="/images/avatar.png" alt="User avatar or testimonial photo" className="feedback-avatar" />
              </div>
              <div className="feedback-stars">★★★★★</div>
            </div>
            <h3 className="feedback-name">Heston A.</h3>
            <p className="feedback-title">Electrician</p>
            <p className="feedback-text">Other than the prices being dialed, the names are really well written and easy to find when we are looking things up.</p>
          </div>
          <div className="feedback-card">
            <div className="feedback-header">
              <div className="feedback-avatar">
                <img src="/images/avatar.png" alt="User avatar or testimonial photo" className="feedback-avatar" />
              </div>
              <div className="feedback-stars">★★★★★</div>
            </div>
            <h3 className="feedback-name">Gabriel H.</h3>
            <p className="feedback-title">Handyman</p>
            <p className="feedback-text">I'm happy to pay another $500 for plumbing and other construction items when they are availible! They have the basics covered for residential electrical so far. </p>
          </div>
          <div className="feedback-card">
            <div className="feedback-header">
              <div className="feedback-avatar">
                <img src="/images/avatar.png" alt="User avatar or testimonial photo" className="feedback-avatar" />
              </div>
              <div className="feedback-stars">★★★★★</div>
            </div>
            <h3 className="feedback-name">Alex T.</h3>
            <p className="feedback-title">Electrical Contractor</p>
            <p className="feedback-text">Im no longer worry about outdated prices or manual errors.</p>
          </div>
          <div className="feedback-card">
            <div className="feedback-header">
              <div className="feedback-avatar">
                <img src="/images/avatar.png" alt="User avatar or testimonial photo" className="feedback-avatar" />
              </div>
              <div className="feedback-stars">★★★★★</div>
            </div>
            <h3 className="feedback-name">Bryan C.</h3>
            <p className="feedback-title">Electrical Contractor</p>
            <p className="feedback-text">We used to go into the hardware store every couple of years to update our own pricelist. Stoked to finally have found this.</p>
          </div>
          <div className="feedback-card">
            <div className="feedback-header">
              <div className="feedback-avatar">
                <img src="/images/avatar.png" alt="User avatar or testimonial photo" className="feedback-avatar" />
              </div>
              <div className="feedback-stars">★★★★★</div>
            </div>
            <h3 className="feedback-name">Nick F.</h3>
            <p className="feedback-title">Contractor</p>
            <p className="feedback-text">Bruce and Hunter spent a lot of time making these price lists and you can really tell when you go through them that they included everything</p>
          </div>
          <div className="feedback-card">
            <div className="feedback-header">
              <div className="feedback-avatar">
                <img src="/images/avatar.png" alt="User avatar or testimonial photo" className="feedback-avatar" />
              </div>
              <div className="feedback-stars">★★★★★</div>
            </div>
            <h3 className="feedback-name">Conrad F.</h3>
            <p className="feedback-title">Contractor</p>
            <p className="feedback-text">Electrial list is good. Waiting for the rest of the lists so I can have everything I need. </p>
          </div>
          {/* Add more feedback cards as needed */}
        </div>
        <div className="feedback-pagination">
          {dots.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => scrollToIndex(index)}
            />
          ))}
        </div>
      </section>

      {/* Learn Everything About Us Section */}
      <section className="learn-section">
        <h2 className="section-heading">Learn Everything About Us</h2>
        <p className="section-subtitle">Explore our blog posts and frequently asked questions to learn more about AccuPrice</p>
        <div className="learn-buttons">
          <Link to="/all-blogs" className="learn-btn" style={{
            display: "inline-block",
            backgroundColor: "orange",
            color: "white",
            padding: "0.75rem 1.5rem",
            fontSize: "1rem",
            fontWeight: "bold",
            borderRadius: "10px",
            textDecoration: "none",
            textAlign: "center",
            cursor: "pointer",
            margin: "0.5rem",
          }}>View Our Blogs</Link>
          <Link to="/faq" className="learn-btn" style={{
            display: "inline-block",
            backgroundColor: "white",
            color: "orange",
            padding: "0.75rem 1.5rem",
            fontSize: "1rem",
            fontWeight: "bold",
            borderRadius: "10px",
            textDecoration: "none",
            textAlign: "center",
            cursor: "pointer",
            margin: "0.5rem",
          }}>See FAQs</Link>
        </div>
      </section>

      {/* Signup Footer Section */}
      <section className="signup-footer">
        <h2>Join AccuPrice Now!</h2>
        <p>Enter your email to stay up to date on our new price lists and updates</p>
        <form className="signup-form" onSubmit={handleemailSubmit}>
          <input 
            type="email" 
            placeholder="Enter your email"
            value={email} 
            onChange={(e) => setEmail(e.target.value)}   
            required 
          />
          <button type="submit">Sign Up</button>
        </form>
      </section>
    </div>
  );
};

export default Home;
